export default {
  BusinessStockComDialogOrder: {
    queryCode: '订单号',
    planNum: '可分配库存',
    platformOrderCode: '客户订单号',
    orderCode: '内部订单号',
    orderCreationDate: '三方下单时间',
    stockoutQty: '缺货数量',
    scheduledDeliveryTime: '预计发货时间',
    replenishQty: '补货数量',
    priorityGrade: '优先级',
    msgWaring1: '补货数量之和不可大于可分配库存',
    msgWaring2: '请输入订单',
    msgWaring3: '的优先级',
  }
};
